import { apiFetch, ApiBaseUrl } from "./fetch";

const ApiCompanyAccesses = {
  // GET /users/:userId/company_accesses
  getAccessibleCompanies: userId => apiFetch(`${ApiBaseUrl}users/${userId}/company_accesses`),

  // PATCH /users/:userId/company_accesses
  // companyAccessesData: array of {slug, role} objects
  // canAccessAllCompanies: boolean - if true, grants access to all companies
  // allCompaniesRole: string - required when canAccessAllCompanies is true
  updateCompanyAccesses: (
    userId,
    companyAccessesData,
    canAccessAllCompanies = false,
    allCompaniesRole = null,
  ) => {
    const body = canAccessAllCompanies
      ? {
          can_access_all_companies: true,
          all_companies_role: allCompaniesRole,
          company_accesses: companyAccessesData, // Specific overrides
        }
      : { company_accesses: companyAccessesData };

    return apiFetch(`${ApiBaseUrl}users/${userId}/company_accesses`, {
      method: "PATCH",
      body,
    });
  },
};

export default ApiCompanyAccesses;
